export function getUserTimezone(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof tz === 'string' && tz ? tz : undefined;
  } catch {
    return undefined;
  }
}
